import React from 'react';
import { connect } from 'react-redux';
import PDFExportMenuItem from '../pdf/PDFExportMenuItem';
import ShareMachineMenuItem from '../sharemachine/ShareMachineMenuItem';

function ImportSection(props) {
	const { isExperimental, isMachineDetailPage } = props;
	return (
		<React.Fragment>
			{isExperimental && isMachineDetailPage ? <PDFExportMenuItem /> : null}
			{isMachineDetailPage ? <ShareMachineMenuItem /> : null}
		</React.Fragment>
	);
}

function mapStateToProps(state) {
	return {
		isExperimental: state.appState.experimental
	};
}

export default connect(mapStateToProps)(ImportSection);



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/MainDrawerExtensions/ImportSection.js